import { supabaseClient } from "@/lib/supabase";
import type { EntryValue } from "@/types/database/entries";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";
import { useEntryValuesStore } from "../../inputs/hooks/useEntryValuesStore";

export async function upsertEntryValues(entryValues: EntryValue["Update"][]) {
	// Ensure each entry value has the required properties
	const validatedEntryValues = entryValues.map((value) => ({
		...value,
		entry_id: value.entry_id || "",
		input_id: value.input_id || "",
	}));

	return await supabaseClient
		.from("entry_values")
		.upsert(validatedEntryValues)
		.select()
		.throwOnError()
		.then((res) => res.data);
}

export const useEntryValuesMutation = (diaryId?: string) => {
	const entryValues = useEntryValuesStore();
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["entry-values"],
		mutationFn: async (entryValues: EntryValue["Update"][]) => {
			return await upsertEntryValues(entryValues);
		},
		onError: () => {
			toast.error("Error creating diary log");
		},
		onSuccess: (data) => {
			entryValues.resetEntryValues();
			toast.info("Entry saved");
			return data;
		},
		onSettled: () => {
			// Pass the diaryId to invalidateDiaries to ensure the specific diary query is invalidated
			invalidateDiaries(diaryId);
		},
	});
};
